import { render } from "./DiscoverySection.vue?vue&type=template&id=46275970&scoped=true"
import script from "./DiscoverySection.vue?vue&type=script&lang=js"
export * from "./DiscoverySection.vue?vue&type=script&lang=js"

import "./DiscoverySection.vue?vue&type=style&index=0&id=46275970&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46275970"]])

export default __exports__